import React, { useContext, useEffect, useState } from 'react';

import { SearchableDropdown } from '@scholastic/volume-react';

import {
  getCustomerInfoFromAPIResponse,
  SearchableDropdownValue,
} from '../../Home/Home.dataparser';
import { parseDates } from '../../../utils/dataparsers.util';

import './GroupDateSelector.scss';
import StepDescription from '../../Home/StepDescription/StepDescription';
import { StoreContext } from '../../../state/store';
import { sortDropdownDates } from '../../../helper/CommonHelper';

export interface GroupDateSelectorProps {
  callback(from: SearchableDropdownValue | null, to: SearchableDropdownValue | null): void;
}

const GroupDateSelector = ({ callback }: GroupDateSelectorProps) => {
  const { state } = useContext(StoreContext);
  const customer = state.customerInfo;

  const [datesFrom, setDatesFrom] = useState<Array<SearchableDropdownValue>>([]);
  const [dateFrom, setDateFrom] = useState<SearchableDropdownValue | null>(null);

  const [datesTo, setDatesTo] = useState<Array<SearchableDropdownValue>>([]);
  const [dateTo, setDateTo] = useState<SearchableDropdownValue | null>(null);

  useEffect(() => {
    if (customer) {
      const datesFromCustomer:
        | { [key: string]: string }
        | undefined = getCustomerInfoFromAPIResponse(customer)?.usagedates;

      const availableDates = sortDropdownDates(parseDates(datesFromCustomer));

      setDatesFrom(availableDates);

      setDatesTo(availableDates);
    }
  }, [customer]);

  return (
    <div className="stats-gds">
      <div className="stats-gds__section-element">
        <StepDescription order="2" description="Select the date range:" />
      </div>

      <div className="stats-gds__section-element">
        <SearchableDropdown
          items={datesFrom}
          placeholder="Search for the Date"
          onItemSelect={(val: SearchableDropdownValue) => {
            setDateFrom(val);
            callback(val, dateTo);
          }}
        />
      </div>

      <div className="stats-gds__section-element">
        <SearchableDropdown
          items={datesTo}
          placeholder="Search for the Date"
          onItemSelect={(val: SearchableDropdownValue) => {
            setDateTo(val);
            callback(dateFrom, val);
          }}
        />
      </div>
    </div>
  );
};

export default GroupDateSelector;
